'use client'; // 꼭 선언해야 함!
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import local from "@/DB/LanguageDB.json";
if (!i18n.isInitialized) {
const keys = Object.keys(local);
const resources = keys.reduce((acc, key) => {
  acc[key] = { translation: local[key] };
  return acc;
}, {}); 

  i18n
    .use(initReactI18next)
    .init({
      lng: typeof window !== 'undefined'
        ? localStorage.getItem('language') || keys[0]
        : keys[0],
      resources,
      fallbackLng: keys[0],
      interpolation: { escapeValue: false },
    });
}
export default i18n;